/**
 * @file CurrentResearchTopics.js
 * @module src/js/components/CurrentResearchTopics
 * @description
 * **CurrentResearchTopics component displaying current research topics on the home page.**
 *
 * @version
 * <p>
 *  2025-11-29: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import ThemeToggledWrapper from "./ThemeToggledWrapper";
import ResearchSections from "./ResearchSections";

export default function CurrentResearchTopics() {
    return (
        <ThemeToggledWrapper id="research" lightStyle={2} darkStyle={4}>
            <div className="inner">
                <header className="major special">
                    <h2>Research Topics</h2>
                </header>
                <ResearchSections />
            </div>
        </ThemeToggledWrapper>
    )
}